import loadable from '@loadable/component';

import './Logout.css';

export default loadable(() => {
  return import('./Logout.jsx');
});
